export const CONTACTS = 'contacts';

// Only for base setup, later should be updated or removed
export type Contact = {
  first_name: string;
  last_name: string;
  dob: string;
};

export type ContactsState = {
  loading: boolean;
  contacts: Contact[];
};
